import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 4 };
const _hoisted_2 = { key: 0 };
import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import AudienceIntegrationsItem from '@/features/AudienceManager/components/Stages/Integrations/AudienceIntegrationsItem.vue';
import AudienceIntegrationSkeleton from '@/features/AudienceManager/components/Stages/Integrations/AudienceIntegrationSkeleton.vue';
import ModalActiveIntegration from '@/features/AudienceManager/components/Stages/Integrations/Modals/ModalActiveIntegration/Modal.vue';
import ModalSuccessIntegrations from '@/features/AudienceManager/components/Stages/Integrations/Modals/ModalSuccessIntegrations.vue';
import ModalErrorIntegrations from '@/features/AudienceManager/components/Stages/Integrations/Modals/ModalErrorIntegrations.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceIntegrationStage',
    setup(__props) {
        const store = useStore();
        const isViewMode = computed(() => store.getters['audienceManager/isView']);
        const activeStepName = computed(() => store.getters['audienceManager/activeStepName']);
        const activeConnectorModal = computed(() => store.getters['audienceManager/activeConnectorModal']);
        const isLoadingIntegrationsStage = computed(() => store.getters['audienceManager/isLoadingIntegrationsStage']);
        const integrationsOptions = computed(() => store.getters['audienceManager/integrationsOptions']);
        const showIntegrationSuccessModal = computed(() => store.getters['audienceManager/showIntegrationSuccessModal']);
        const showIntegrationErrorModal = computed(() => store.getters['audienceManager/showIntegrationErrorModal']);
        const fetchListAllConnectors = () => {
            store.dispatch('audienceManager/fetchListConnectors');
        };
        watch(() => activeStepName.value, () => {
            if (activeStepName.value === 'integration') {
                fetchListAllConnectors();
            }
        }, { deep: true, immediate: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (activeConnectorModal.value.isVisible)
                    ? (_openBlock(), _createBlock(ModalActiveIntegration, {
                        key: 0,
                        data: activeConnectorModal.value
                    }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                (showIntegrationSuccessModal.value)
                    ? (_openBlock(), _createBlock(ModalSuccessIntegrations, {
                        key: 1,
                        "is-visible": showIntegrationSuccessModal.value
                    }, null, 8, ["is-visible"]))
                    : _createCommentVNode("", true),
                (showIntegrationErrorModal.value)
                    ? (_openBlock(), _createBlock(ModalErrorIntegrations, {
                        key: 2,
                        "is-visible": showIntegrationErrorModal.value
                    }, null, 8, ["is-visible"]))
                    : _createCommentVNode("", true),
                (isLoadingIntegrationsStage.value)
                    ? (_openBlock(), _createBlock(AudienceIntegrationSkeleton, { key: 3 }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("h2", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('audiences.integration.title')) + " ", 1),
                            (!isViewMode.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.$t('optional')) + ")", 1))
                                : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(integrationsOptions.value, (integrationRow, index) => {
                            return (_openBlock(), _createBlock(AudienceIntegrationsItem, {
                                key: index,
                                data: integrationRow
                            }, null, 8, ["data"]));
                        }), 128))
                    ]))
            ]));
        };
    }
});
